module.exports = __webpack_public_path__ + "src/font/woff/a38a17072c42b8f41d004a5936e1227b.woff";